import { InjectionToken } from '@angular/core';
import Graphic from '@arcgis/core/Graphic.js';
import MapView from '@arcgis/core/views/MapView';
import LayerList from '@arcgis/core/widgets/LayerList.js';

export interface ArcgisMapLifecycle {
	onMapInit?(): void;
	onStartStretch?(graphic: Graphic): void;
	onCompleteStretch?(graphic: Graphic): void;
	onViewReady?(view: MapView, basemap?: string, mapDisplayOptions?: any): void;
	onLayerListReady?(layerList: LayerList): void;
	onBasemapGalleryReady?(basemapGallery: any): void;
	onHandleActionClicks?(action: any): void;
	onViewDestroyed?(): void;
}

export const ARCGIS_MAP_LIFECYCLE = new InjectionToken<ArcgisMapLifecycle>(
	'ARCGIS_MAP_LIFECYCLE',
);
